export const cloudDisplayModeDefaultOptions = {
  maxLines: 2,
  isFolded: true,
  isFoldable: true
};